<template>
  <div style="width: 100%">
    <div class="row">
      <div class="col-12">
        <card class="custom-shadow-card-header">
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="(item, index) in pagination.perPageOptions"
                  :key="`${item}-${index}`"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                style="width: 100%"
                :data="queriedData"
                :border="true"
              >
                <el-table-column
                  type="index"
                  width="80"
                  :align="'center'"
                  :resizable="false"
                ></el-table-column>
                <el-table-column
                  v-for="(column, index) in tableColumns"
                  :key="`${column.label}-${index}`"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  :fixed="column.fixed"
                  :sortable="column.sortable"
                  :align="column.align"
                  :resizable="false"
                ></el-table-column>
                <el-table-column
                  :min-width="120"
                  :label="$t('common_words.operations')"
                  fixed="right"
                  :resizable="false"
                >
                  <template slot-scope="props">
                    <div class="text-center">
                      <a
                        v-if="isShow()"
                        v-tooltip.top-center="$t('common_words.view')"
                        class="btn-info btn-simple btn-link custom-margin-actions"
                        @click="handleView(props.$index, props.row)"
                      >
                        <em class="fa fa-eye custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.edit')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click="handleEdit(props.$index, props.row)"
                      >
                        <em class="fa fa-edit custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>
        </card>
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="
                  exportToPDF({
                    route: 'fertilization/budgeted_card_schedules/pdf',
                    name_file: 'cronogramas_cedulas.pdf',
                  })
                "
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="
                  exportToExcel({
                    route: 'fertilization/budgeted_card_schedules/excel',
                    name_file: 'cronogramas_cedulas.xlsx',
                  })
                "
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-4" v-if="viewDetails">
        <card class="custom-shadow-card-header">
          <div class="row content-add-btn">
            <div class="col-12 text-center">
              <h6 class="text-muted">
                {{ $t('fertilization.budgeted_card_cronogram') }} -
                {{ budgetedCardForm.year }}
              </h6>
            </div>
          </div>
          <br />
          <div v-if="isIndex()">
            <div class="col-sm-12">
              <el-table
                stripe
                style="width: 100%"
                :data="tableViewData"
                :border="true"
              >
                <el-table-column
                  :label="$t('fertilization.fertilizer')"
                  prop="fertilizer"
                  min-width="130"
                  fixed
                ></el-table-column>
                <el-table-column
                  :label="$t('production.bundle_quantity_cycle')"
                >
                  <el-table-column
                    :formatter="formatterNumberMS"
                    v-for="(column, index) in tableCyclesColumns"
                    :key="`${column.label}-${index}`"
                    :min-width="column.minWidth"
                    :prop="column.prop"
                    :label="column.label"
                  >
                  </el-table-column>
                </el-table-column>
                <el-table-column
                  :label="$t('common_words.total')"
                  prop="total"
                  min-width="100"
                  fixed="right"
                >
                  <template slot-scope="props">
                    <strong> {{ formatterNumber(props.row.total) }} </strong>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('common_words.recommended')"
                  prop="recommended"
                  min-width="130"
                  fixed="right"
                  :resizable="false"
                >
                  <template slot-scope="props">
                    <strong>
                      {{ formatterNumber(props.row.recommended) }}
                    </strong>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
        </card>
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="
                  exportToPDF({
                    route:
                      'fertilization/budgeted_card_schedules/pdf/' +
                      budgetedCardForm.id,
                    name_file: 'cronograma_cedula.pdf',
                  })
                "
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="
                  exportToExcel({
                    route:
                      'fertilization/budgeted_card_schedules/excel/' +
                      budgetedCardForm.id,
                    name_file: 'cronograma_cedula.xlsx',
                  })
                "
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import Formatter from 'src/class/Formatter';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import configTable from './budgetedCardScheduleTable';

export default {
  computed: {
    ...configTable().Search,
  },
  data() {
    return {
      budgetedCardForm: {},
      pagination: {},
      tableColumns: [],
      tableCyclesColumns: [],
      tableViewData: null,
      viewDetails: false,
    };
  },

  mixins: [mixinMasters, MixinPermissions, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    formatterNumber(value) {
      return Formatter.formatMoney(Number(value));
    },

    handleView(index, row) {
      this.budgetedCardForm = Object.assign({}, row);
      this.tableCyclesColumns = Object.assign(
        [],
        row.fertilization_cycles_columns
      );
      this.tableViewData = Object.assign([], row.table_data_elements);
      this.viewDetails = true;

      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 100);
    },

    handleEdit(index, row) {
      this.budgetedCardForm = Object.assign({}, row);
      sessionStorage.setItem(
        'createEditForm',
        JSON.stringify(this.budgetedCardForm)
      );
      this.$router.push({
        path: '/fertilization/budgeted_card_schedules/edit',
      });
    },

    exportToPDF(data) {
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel(data) {
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    setupTable() {
      const { Table } = configTable();
      // Assign the Table and Search objects to your data properties
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);

      Axios.getMasters('fertilization/budgeted_card_schedules')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((prop) => {
              return prop.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('fertilization');
  },

  destroyed() {
    this.deselectedItemOnMenu('fertilization');
  },
};
</script>
